import { render, staticRenderFns } from "./time.vue?vue&type=template&id=2fae7ad3&scoped=true&"
import script from "./time.vue?vue&type=script&lang=js&"
export * from "./time.vue?vue&type=script&lang=js&"
import style0 from "./time.vue?vue&type=style&index=0&id=2fae7ad3&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fae7ad3",
  null
  
)

export default component.exports